import * as React from 'react';
export const comdirectSvg = React.forwardRef(function comdirectSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#29373C',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF500',
        fillRule: 'nonzero',
        d: 'M8.73 16c0 4.97 3.55 8.73 8.99 8.73 2.54 0 4.83-.9 6.38-2.65l-2.31-2.5a6.3 6.3 0 0 1-4.18 1.74c-2.88 0-5.04-2.18-5.04-5.32 0-3.13 2.18-5.3 5.04-5.3 1.54 0 3 .6 4.1 1.7l2.4-2.48a8.3 8.3 0 0 0-6.4-2.65c-5.42 0-8.98 3.76-8.98 8.73z',
      }),
    ),
  );
});
comdirectSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var comdirect = {
  category: 'brand',
  colorable: false,
  name: 'comdirect',
  svg: comdirectSvg,
};
